import { ExceptionService } from '../services/exception.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DipStateService } from 'app/services/dip-state-service.service';
import { TogetherDIPStageContainer } from 'app/models/app.models';
import { NodeAPIEntityService } from 'app/services/node.entity.service';
import { TogetherAuctionDIPEntityType, SubmissionRequestStatus } from 'app/models/enums';
import { TogetherAuctionDIPQuoteResult } from 'app/models/api.models';

@Component({
    selector: 'dip-submission',
    templateUrl: './dip-submission.component.html',
    styleUrls: ['./dip-submission.component.scss'],
    standalone: false
})
export class DipSubmissionComponent implements OnInit {
    /**
     * current stage meta data
     * 
     * @type {TogetherDIPStageContainer}
     * @memberof DipSubmissionComponent
     */
    @Input() stage: TogetherDIPStageContainer;
    /**
     * Event emitter to notify parent of changing stage
     * 
     * @type {EventEmitter<string>}
     * @memberof DipSubmissionComponent
     */
    @Output() stageChanging: EventEmitter<string> = new EventEmitter<string>();
    /**
     * The id of the case geing processed
     * 
     * @type {string}
     * @memberof DipOverviewComponent
     */
    @Input() caseId: string;
    /**
     * Is the comonent in a loading state, i.e. processing something
     * 
     * @type {boolean}
     * @memberof DipSubmissionComponent
     */
    isLoading: boolean = true;
    /**
     * Creates an instance of DipSubmissionComponent.
     * @param {DipStateService} state 
     * @param {NodeAPIEntityService} entity 
     * @memberof DipSubmissionComponent
     */
    constructor(private state: DipStateService,
        private entity: NodeAPIEntityService,
        private exception: ExceptionService) {
    }
    /**
     * Initialise the component
     * 
     * @memberof DipSubmissionComponent
     */
    ngOnInit() {
        // *TODO* Call get current state from API to workout where to redirect to 
        //  if not SubmissionRequestStatus.Initialised
        if (this.state.dipSubmissionStatus === SubmissionRequestStatus.Initialised) {
            this.submitDip(this.caseId);
        } else if (this.state.dipSubmissionStatus === SubmissionRequestStatus.Uninitialised) {
            this.stageChanging.emit('tad_stage_dip_overview');
        } else {
            this.stageChanging.emit('tad_stage_outcome');
        }
    }
    /**
     * Call the API to submit the case
     * 
     * @private
     * @param {any} caseId 
     * @memberof DipSubmissionComponent
     */
    private submitDip(caseId) {
        this.state.dipSubmissionStatus = SubmissionRequestStatus.Inprogress;
        this.entity.getAllEntities(TogetherAuctionDIPEntityType.SubmitDIP, caseId)
            .subscribe(
            (success) => {
                this.state.dipSubmissionStatus = SubmissionRequestStatus.Complete;
                this.stageChanging.emit('tad_stage_outcome');
            },
            (error) => {
                this.exception.haveReceivedError(error);
                this.isLoading = false;
            },
        );
    }

}
